import type { AdminModule } from '@ciptaimaji/shared';
import type { LucideIcon } from 'lucide-react';
import {
  BarChart3,
  BookOpen,
  Bot,
  ClipboardList,
  History,
  FileText,
  FolderTree,
  Handshake,
  GalleryHorizontal,
  Image,
  LayoutTemplate,
  LayoutDashboard,
  Newspaper,
  Package,
  UserCog,
  ShoppingBag,
  Users,
} from 'lucide-react';

export interface AdminNavItem {
  label: string;
  icon: LucideIcon;
  href: string;
  exact?: boolean;
  /** Belum dibangun: tampil redup dan tidak bisa diklik. */
  soon?: boolean;
  /** Menu hak akses yang menjaga halaman ini. Tanpa module = hanya super admin. */
  module: AdminModule | null;
}

export interface AdminNavGroup {
  label: string;
  items: AdminNavItem[];
}

export const ADMIN_NAV: AdminNavGroup[] = [
  {
    label: 'Ringkasan',
    items: [
      { label: 'Dashboard', icon: LayoutDashboard, href: '/', exact: true, module: 'dashboard' },
      { label: 'Laporan', icon: BarChart3, href: '/laporan', module: 'revenue' },
    ],
  },
  {
    label: 'Konten',
    items: [
      { label: 'Artikel', icon: Newspaper, href: '/artikel', module: 'articles' },
      { label: 'Halaman', icon: FileText, href: '/halaman', module: 'pages' },
      { label: 'Media', icon: Image, href: '/media', module: 'media' },
      { label: 'Banner', icon: GalleryHorizontal, href: '/banner', module: 'banners' },
    ],
  },
  {
    label: 'Katalog',
    items: [
      { label: 'Produk', icon: Package, href: '/produk', module: 'products' },
      { label: 'Kategori', icon: FolderTree, href: '/kategori', module: 'categories' },
      { label: 'Layanan', icon: Handshake, href: '/layanan', module: 'services' },
      { label: 'Imaji Studio', icon: LayoutTemplate, href: '/studio', module: 'studio' },
    ],
  },
  {
    label: 'Transaksi',
    items: [
      { label: 'Pesanan', icon: ShoppingBag, href: '/pesanan', module: 'orders' },
      { label: 'Pelanggan', icon: Users, href: '/pelanggan', module: 'customers' },
    ],
  },
  {
    label: 'Bantuan',
    items: [
      { label: 'Asisten AI', icon: Bot, href: '/asisten', module: 'assistant' },
      { label: 'Knowledge Base', icon: BookOpen, href: '/pengetahuan', module: 'knowledge' },
    ],
  },
  {
    label: 'Pengaturan',
    items: [
      {
        label: 'Topik Internal',
        icon: ClipboardList,
        href: '/topik-internal',
        module: 'internalTopics',
      },
      { label: 'Users & Roles', icon: UserCog, href: '/users-roles', module: null },
      { label: 'Log aktivitas', icon: History, href: '/log-aktivitas', module: null },
    ],
  },
];

/** Item menu yang menjaga `pathname`; null untuk halaman di luar menu. */
export function navItemFor(pathname: string): AdminNavItem | null {
  const items = ADMIN_NAV.flatMap((group) => group.items).filter((item) => !item.soon);
  const matches = items.filter((item) =>
    item.exact
      ? pathname === item.href
      : pathname === item.href || pathname.startsWith(`${item.href}/`),
  );
  // Yang paling panjang menang, supaya '/' tidak menelan semua halaman.
  return matches.sort((a, b) => b.href.length - a.href.length)[0] ?? null;
}
